import { mergeDeepRight } from 'ramda';
import { derived, get, readable, writable } from 'svelte/store';

// https://svelte.dev/docs#readable
const ConstantCell = (defaultValue, initFn) => {
  const op = readable(defaultValue, initFn);

  op.value = () => get(op);

  return op;
};

// https://svelte.dev/docs#writable
const ValueCell = defaultValue => {
  const op = writable(defaultValue);

  op.value = () => get(op);
  op.reset = () => op.set(defaultValue);

  return op;
};

const ObjectCell = defaultValue => {
  const op = ValueCell(defaultValue);

  op.merge = obj => op.set(mergeDeepRight(op.value(), obj));

  return op;
};

// https://svelte.dev/docs#derived
const FormulaCell = (cells, callbackFn) => {
  const op = derived(cells, callbackFn);

  op.value = () => get(op);

  return op;
};

export { ConstantCell, ValueCell, ObjectCell, FormulaCell };
